import React from 'react';
function BlankPageMessage(props){
    const message =props.message;
    return (
        <div className="blankPage border">
            <h5><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> &nbsp;{message}</h5>
        </div>
    )
}
export default BlankPageMessage